import React, { Component } from 'react';

import { __ } from '../../lib/I18n';

const styles = {
  agreementContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '2.5rem',
    width: '23rem',
    textAlign: 'center'
  },
  agreementText: {
    color: '#999999'
  },
  agreementTextLink: {
    color: '#0069ff',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  }
};

const terms = {
  href: 'https://classapp.com.br/terms?type=admin+staff',
  text: __('termos de uso')
};

const privacy = {
  href: 'https://www.classapp.com.br/privacy',
  text: __('política de privacidade')
};

export default class TermsAndPrivacy extends Component {
  render() {
    return (
      // @ts-ignore
      <div style={styles.agreementContainer}>
        <span style={styles.agreementText}>{__('Ao acessar, você concorda com os nossos')}</span><br /><a href={terms.href} target="_blank" style={styles.agreementTextLink}>{terms.text}</a> <span style={styles.agreementText}>e</span> <a href={privacy.href} target="_blank" style={styles.agreementTextLink}>{privacy.text}</a>
      </div>
    );
  }
}
